import React, {Fragment} from "react";

import {Button, Col, Container, Nav, Row} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Password from "./Password";
import Asset from "./Asset";
import Contact from "./Contact";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";


export default function Profile(){
    let state=useSelector((state)=> state);
    const saveMapData=()=>{
        navigator.geolocation.getCurrentPosition((position)=>{

            RestClient.PostRequest(AppUrl.updateData, {"sql": "Insert Into Officer_Attendence (Id,Name,Posting,Latitude,Longitude,Entry_Date)" +
                    "Values(Null,'"+state.name+"','"+state.access+"',Latitude="+position.coords.latitude+", Longitude="+position.coords.longitude+", '"+appUtility.getDate(new Date())+"')   "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Location saved")

                } else {
                    cogoToast.error("Location not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        })

    }
    return(
        <Fragment>
            <div className="purchaseDiv text-center">
                <Nav className="navItem float-end"><NavLink to="/home"><Button variant="warning" >Close</Button></NavLink></Nav>
                <h3>User Profile</h3>
                <hr/>
                <Tabs
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="home" title="Home">
                        <Button className=""  variant="primary" onClick={saveMapData} >Add Map Location</Button>
                    </Tab>
                    <Tab eventKey="profile" title="Profile">

                    </Tab>
                    <Tab eventKey="contact" title="Contact" >
                        <Contact/>
                    </Tab>
                    <Tab eventKey="asset" title="Asset" >
                        <Asset/>
                    </Tab>
                    <Tab eventKey="performance" title="Performance" >

                    </Tab>
                    <Tab eventKey="email" title="Email" >

                    </Tab>
                    <Tab eventKey="password" title="Password" >
                       <Password/>
                    </Tab>
                </Tabs>
            </div>
        </Fragment>
    )
}
